import type { Health } from '../types'
import { StatusBadge } from './StatusBadge'

const ORDER: Health[] = ['blocked', 'error', 'degraded', 'ok', 'no_data']

export function Legend() {
  return (
    <div className="flex flex-wrap items-center gap-2">
      {ORDER.map((h) => (
        <StatusBadge key={h} health={h} />
      ))}
    </div>
  )
}
